import { useEffect } from "react";
import styles from "./progressbar.module.scss"
interface ProgressbarProps {
  currentValue: number,
  totalValue: number,
  toLeft ?: boolean 
}


function Progressbar({ currentValue, totalValue ,toLeft}: ProgressbarProps) {

  return <div className={styles.progress}>
    <div className={`${styles.progressbar} ${toLeft ? styles.toLeft : styles.toRight}`}  role="progressbar" aria-valuenow={70}
      aria-valuemin={0} aria-valuemax={100} style={{ width: `${((currentValue) / totalValue) * 100}%`}}>
    </div>
  </div>
}

export default Progressbar; 